import styled from 'styled-components'


// Background
export const BackgroundLarge = styled.div`
  background-color: #F6F6F6;
`
export const BackgroundMedium = styled.div`
  background-color: #1F2023;
`
export const BackgroundSmall = styled.div`
  background-color: #1F2023;
`

// Text
export const TextLarge = styled.p`
  font-size: 14px;
  color: #1F2023;
`
export const TextLargeClean = styled.p`
  font-size: 14px;
  color: #1F2023;
  margin-top: 0px;
`
export const TextMedium = styled.p`
  font-size: 13px;
  color: #1F2023;
`
export const TextMediumClean = styled.p`
  font-size: 13px;
  color: white;
  margin-top: 0px;
`
export const TextSmall = styled.p`
  font-size: 12px;
  color: white;
`

// Title
export const TitleLarge = styled.p`
  margin-top: 10px;
  font-family: 'reason01';
  font-size: 10vw;
  letter-spacing: -3px;
  line-height: 85%;
  color: #1F2023;
`

export const TitleLarge2 = styled.p`
  margin: 0px;
  margin-top: 0vw;
  font-family: 'reason02';
  font-size: .8vw;
  letter-spacing: 0px;
  line-height: 45%;
  color: #1F2023;
`

export const TitleLarge3 = styled.p`
  display: inline-block;
  margin: 0px;
  font-family: 'reason03';
  font-size: 2.2vw;
  letter-spacing: 1px;
  line-height: 90%;
  color: #1F2023;
`

export const TitleLarge4 = styled.p`
  display: inline-block;
  margin: 0px;
  margin-right: 10px;
  font-family: 'reason04';
  font-size: 2.2vw;
  letter-spacing: 0px;
  line-height: 90%;
  color: #1F2023;
`

export const TitleLarge5 = styled.p`
  margin-top: 10px;

  margin-bottom: 2vw;
  font-family: 'reason05';
  font-size: .6vw;
  letter-spacing: 3px;
  line-height: 55%;
  color: #1F2023;
`

export const TitleLarge6 = styled.p`
  margin-top: 24px;
  font-family: 'reason01';
  font-size: 3.2vw;
  letter-spacing: 3px;
  line-height: 55%;
  color: #1F2023;
`

export const TitleMedium = styled.p`
  margin-top: 0px;
  font-size: 80px;
  letter-spacing: -1.6px;
  color: #1F2023;
`
export const TitleSmall = styled.p`
  margin-top: 0px;
  font-size: 65px;
  letter-spacing: -.6px;
  color: #1F2023;
`

// Logo
export const LetterOne = styled.div`
  background: url(${require('../../../svg/1.svg')}) no-repeat;
  background-size: 100% 100%;
  background-position-y: top;
  width: 100%;
  height: 100%;
`
export const LetterTwo = styled.div`
  background: url(${require('../../../svg/2.svg')}) no-repeat;
  background-size: 100% 100%;
  background-position-y: top;
  width: 100%;
  height: 100%;
`
export const LetterThree = styled.div`
  background: url(${require('../../../svg/3.svg')}) no-repeat;
  background-size: 100% 100%;
  background-position-y: top;
  width: 100%;
  height: 100%;
`
export const LogoSmall = styled.div`
  background: url(${require('../../../svg/logo.svg')}) no-repeat;
  width: 100%;
  height: 100%;
  background-size: contain;
`
export const LogoTiny = styled.div`
  background: url(${require('../../../svg/logo.svg')}) no-repeat;
  width: 50px;
  height: 20px;
  background-size: 45px auto;
`



const Title = styled.h1`
  font-size: 1.5em;
  text-align: center;
  color: palevioletred;
`

export const Wrapper = styled.div`
  overflow: hidden;
  height: 32vh;
`

export const WrapperInline = styled.div`
  overflow: hidden;
  height: 32vh;
  display: inline-block;
`

const Thing = styled.button`
  color: blue;

  ::before {
    content: '🚀';
  }

  :hover {
    color: red;
  }
`


export const BigHeadlineOne = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #1F2023;
  line-height: 75%;
  user-select: none;
  transform: translate(0,43vh);
`

export const BigHeadlineTwo = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #1F2023;
  margin-left: 34vh;
  line-height: 75%;
  user-select: none;
  transform: translate(0,35vh);
`

export const BigHeadlineTwoMargin = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #1F2023;
  line-height: 75%;
  user-select: none;
  display: inline-block;
  transform: translate(0,35vh);
`

export const BigHeadlineThree = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #1F2023;
  line-height: 75%;
  user-select: none;
  transform: translate(0,35vh);
`

export const BigHeadlineWrapper = styled.div`
  position: absolute;
  margin-top: 2vh;
  left: 1vh;
`

export const BigHeadlineWrapperMargin = styled.div`
  position: absolute;
  margin-top: 2vh;
  margin-left: -5vh;
  left: 1vh;
`

export const AdTextWrapper = styled.div`
  margin-top: 2vh;
  margin-left: 1vh;
  left: 1vh;
  display: inline-block;
`

export const TitleLarge2s = styled.p`
  margin: 0px;
  margin-top: 40px;
  font-family: 'reason02';
  font-size: 10px;
  letter-spacing: 0px;
  line-height: 45%;
  color: #1F2023;
  user-select: none;
`

export const TitleLarge3s = styled.p`
  display: inline-block;
  margin: 0px;
  font-family: 'reason03';
  font-size: 24px;
  letter-spacing: 1px;
  line-height: 90%;
  color: #1F2023;
  user-select: none;
`

export const TitleLarge4s = styled.p`
  display: inline-block;
  margin: 0px;
  margin-right: 10px;
  font-family: 'reason04';
  font-size: 24px;
  letter-spacing: 0px;
  line-height: 90%;
  color: #1F2023;
  user-select: none;
`

export const TitleLarge5s = styled.p`
  margin-top: 10px;
  margin-bottom: 18px;
  font-family: 'reason05';
  font-size: 7px;
  letter-spacing: 3px;
  line-height: 55%;
  color: #1F2023;
  user-select: none;
`

export const HeadPhoto = styled.div`
  width: 100vw;
  height: 55vw;
  background-color: #BEAB7A;
  margin-top: 5vh;
  user-select: none;
`
